import React, {Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {toFixedFeatureCost} from "../../../misc/helpers";
import {MEASURE_UNITS, SQFT_FEATURES} from "../../sqft/constants";
import {getPriceWithIncluded} from "../../../misc/priceFunctions";
import sqftConfig from "../../sqft/components/canvas/store/sqftConfig";

const SqftFeaturesPopupFeaturePrice = (props) => {

  const {sqftFeature, fabricatorData, intl, measureUnit, isSlabPricingEnabled } = props;
  const {feature, relatedParentFeature, quantity, displayFakeQuantity, displayFakePrice, unit} = sqftFeature;
  const shouldSkipCeilPrice = measureUnit === MEASURE_UNITS.Metric || sqftConfig.shouldUseCabinetDoorsSQFT

  //Ceil price if feature is not edges in metric
  const getFeaturePrice = () => {
    // split total price by quantity of each feature
    //const useSlabPriceCalculation = sqftFeature.shouldUseSlabPricing;
    // split total price by quantity only if isSlabPricingEnabled;
    const useSlabPriceCalculation = sqftFeature.partId === SQFT_FEATURES.slabs && isSlabPricingEnabled;
    const featureToGetPrice = sqftConfig.shouldUseCabinetDoorsSQFT && relatedParentFeature
      ? relatedParentFeature
      : feature;

    if (sqftFeature.group && sqftFeature.group.totalQuantity) {
      const toFixedFeatureCostParams = [featureToGetPrice, Math.ceil(sqftFeature.group.totalQuantity), "", false, null, useSlabPriceCalculation]
      const featureGroupTotalPrice = toFixedFeatureCost(...toFixedFeatureCostParams);
      featurePrice = featureGroupTotalPrice / sqftFeature.group.totalQuantity * sqftFeature.quantity;
      if (!shouldSkipCeilPrice) {
        featurePrice = Math.ceil10(featurePrice, -2);
      }
    } else {
      const quantityToCalculateCost = shouldSkipCeilPrice ? quantity :  Math.ceil(quantity);
      const toFixedFeatureCostParams = [featureToGetPrice, quantityToCalculateCost, "", false, null, useSlabPriceCalculation]
      featurePrice = toFixedFeatureCost(...toFixedFeatureCostParams); // displays included price
    }

    return featurePrice
  }

  //const featurePrice = feature ? toFixedFeatureCost(feature, quantityRounded) : null; // displays price
  let featurePrice;
  if (!feature) {
    featurePrice = null
  } else {
    featurePrice = getFeaturePrice();
  }
  const realUnit = unit; //: getFeatureUnit(feature, intl, fabricatorData, quantity);
  const displayQuantity = parseFloat(displayFakeQuantity) === displayFakeQuantity ? displayFakeQuantity : quantity;
  const displayPrice = parseFloat(displayFakePrice) === displayFakePrice ? displayFakePrice : featurePrice;
  const hideCheckoutBreakdownCost = fabricatorData.hideCheckoutBreakdownCost;

  return (
    <Fragment>
      {displayQuantity ? (
        <div className="sqft-popup__feature-price">
          {displayQuantity} {realUnit}
        </div>
      ) : null}
      {feature && !hideCheckoutBreakdownCost && displayFakePrice !== 0 ? (
        <Fragment>
          {displayQuantity ? <div className="sqft-popup__feature-price">/</div> : null}
          <div className="sqft-popup__feature-price">
            {getPriceWithIncluded(displayPrice, feature, fabricatorData, intl.messages)}
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  )
};

SqftFeaturesPopupFeaturePrice.propTypes = {
  sqftFeature: PropTypes.object.isRequired,
};

const mapStateToProps = (store, ownProps) => {
  return {
    measureUnit: store.sqftState.measureUnit,
    fabricatorData: store.fabricatorState,
    featureId: ownProps.sqftFeature.feature ? ownProps.sqftFeature.feature.dbFeature.id : null,
    isSlabPricingEnabled: store.sqftSlabState.isSlabPricingEnabled,
  };
};
const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeaturePrice)
)
